const func = $target => {
	var $modal = $target.find('#navModal'),
		$toggle = $target.find('.btn-toggle'),
		$close = $modal.find('.btn-close'),
		$body = $('body');

	$toggle.on('click', function(e) {
		e.preventDefault();
		$modal.modal({
			keyboard: false
		});
	});

	$close.on('click', function(e) {
		e.preventDefault();
		$modal.modal('hide');
	});

	$modal.on('show.bs.modal', function(e) {
		$body.addClass('modal-backdrop-nav');
		$toggle.attr('aria-expanded', 'true');
		$close.attr('aria-expanded', 'true');
	});

	$modal.on('hidden.bs.modal', function(e) {
		$body.removeClass('modal-backdrop-nav');
		$toggle.attr('aria-expanded', 'false');
		$close.attr('aria-expanded', 'false');
	});
};

export default func;
